<template>
    <div class="we-toggle-text small ">
        <div
            class="fast-filter-text"
            :class="{
                active: this.fastFilterDateInterval === 'users',
            }"
            @click="manageFastFilterSelected('users')"
        >
            Usuarios
        </div>
        <div
            class="fast-filter-text"
            :class="{
                active: this.fastFilterDateInterval === 'admin',
            }"
            @click="manageFastFilterSelected('admin')"
        >
            Admin
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            fastFilterDateInterval: "users",
        };
    },
    methods: {
        manageFastFilterSelected(optionSelected) {
            this.fastFilterDateInterval = optionSelected;
            this.$emit("fastFilterChange", optionSelected);
        },
    },
};
</script>
<style lang="scss" scoped>
.small {
    & > div {
        padding: 3px 8px;
        min-width: 30px;
        height: unset;
        font-size: 14px;
    }
}
@media only screen and (max-width: 1060px) {
  .fast-filter-text {
      font-size: 12px !important;
    }
}
</style>